import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './signup_captcha.scss';
import { FormattedMessage } from 'react-intl';
import {
  captchaSuccess,
  getCaptchaSourcePageFromUrl,
} from '../../../../captcha/captchaUtils';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';

/* eslint-disable camelcase */
interface CustomWindow extends Window {
  recaptcha_site_key: string;
}
/* eslint-enable camelcase */

declare let window: CustomWindow;

type State = {
  showCaptcha: boolean;
};

export class SignUpCaptcha extends React.Component<{}, State> {
  state: State = {
    showCaptcha: false,
  };

  sourcePage: string | null = getCaptchaSourcePageFromUrl();

  componentDidMount() {
    doctrineAnalytics('Static CaptchaLoaded', { sourcePage: this.sourcePage });
  }

  openForCaptcha = () => {
    doctrineAnalytics('Captcha SeeCaptchaClicked', {
      sourcePage: this.sourcePage,
    });
    this.setState({ showCaptcha: true });
  };

  render() {
    return (
      <div className="signup-captcha">
        {!this.state.showCaptcha ? (
          <div className="signup-captcha__access">
            <FormattedMessage id="signup/routes/user/captcha/SignUpCaptcha.tsx/1" />{' '}
            <button
              className="signup-captcha__access__button"
              type="button"
              onClick={this.openForCaptcha}
            >
              <FormattedMessage id="signup/routes/user/captcha/SignUpCaptcha.tsx/2" />
            </button>
          </div>
        ) : (
          <>
            <div className="signup-captcha__group">
              <MaterialIcon
                name="info"
                className="signup-captcha__group__icon"
              />
              <div>
                <div className="signup-captcha__group__text">
                  <FormattedMessage id="signup/routes/user/captcha/SignUpCaptcha.tsx/3" />{' '}
                  <em>
                    <FormattedMessage id="signup/routes/user/captcha/SignUpCaptcha.tsx/4" />
                  </em>{' '}
                  <FormattedMessage id="signup/routes/user/captcha/SignUpCaptcha.tsx/5" />
                </div>
                <div className="signup-captcha__group__captcha">
                  <FormattedMessage id="signup/routes/user/captcha/SignUpCaptcha.tsx/6" />
                  {'\u00a0'}
                  <FormattedMessage id="signup/routes/user/captcha/SignUpCaptcha.tsx/7" />
                </div>
                <ReCAPTCHA
                  theme="light"
                  sitekey={window.recaptcha_site_key}
                  onChange={captchaSuccess}
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
